// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/** Esto es por callout (Refactorize next version) */\n.overflow-hidden {\r\n  overflow: visible !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
